import type { ValueOf } from 'type-fest';

import type { RunesCalloutInferenceBase } from '../runesCalloutInferenceBase';

export const enum PillDisplayType {
  pill = 1,
  text = 2,
}

export type PartUuid = string;

export const PART_BOT_RESULT_GROUPS = {
  QUOTE_SETUP: 'Quote setup',
  REQUIREMENTS: 'Requirements',
  FEATURES: 'Features',
  DIMENSIONS: 'Dimensions',
  REGIONS: 'Regions',
} as const;

// Raw callout data from backend
export type PartBotResultJson = RunesCalloutInferenceBase & {
  category: string;
  group: ValueOf<typeof PART_BOT_RESULT_GROUPS>;
  value: string;
  displayType: PillDisplayType;
  filename: string;
  canAuthorRule: boolean;
};

// value as a key (so its de-duplicated) to the array of part bot results so they
//  can be individually rendered when clicking
export type ResultValueMap = Record<string, PartBotResultJson[]>;
// Map of category to the value map, so we can display them in a grouped fashion
export type PartBotResultEntries = Record<string, ResultValueMap>;

export type PartBotResults = {
  raw: PartBotResultJson[];
  formatted: PartBotResultEntries;
  withGroupsDeduplicated: Record<string, Record<string, ResultValueMap>>;
  withGroupsDuplicated: Record<string, Record<string, PartBotResultJson[]>>;
};
